import React, { Component } from 'react';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Isvg from 'react-inlinesvg';
import {
    Row,
    Col,
    Table,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import saveIcon from '../../assets/save.svg';
import printIcon from '../../assets/print.svg';
import garbageOpionIcon from '../../assets/garbage-option.svg';
import DeleteModal from '../../components/deleteModal';
import { required, number, minValue, maxValue, minLength, maxLength, length, email } from '../../form-builder/validation';
import { API_ENDPOINT } from '../../constants';
import FileField from '../../form-builder/fields/file';
import exportIcon from '../../assets/export.svg';

class Home extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            articlesList: true,
            articleForm: false,
            total: 20,
            items: [

            ],
            articleTypes: [],
            groups: [],
            subgroups: [],
            manufacturers: [],
            atc: [],
            shapes: [],
            modes: [],
            attributes: [],
            categories: []
        }
    }



    componentDidMount() {
        this._onLoad();

        this._api('categories', {}, (data) => {
            this.setState({ categories: data.categories })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }
    }

    export = () => {
        fetch(API_ENDPOINT + '/data/categories/export', {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
        }).then(res => res.blob()).then(data => { if (data) window.open(URL.createObjectURL(data)) })
    }

    render() {
        let params = this._getParams();

        console.log(this.state.categories)
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Categoires'.translate(this.props.lang)}</h1>

                    <div className='buttons'>
                        <div className="ff-export">
                            <button className='btn-primary' onClick={this.export}><div className="icon"><Isvg src={exportIcon} /></div>Export excel</button>
                        </div>
                        <FileField label={'Import excel'} endpoint={'/data/categories/import'}></FileField>

                    </div>

                </div>

                {
                    this.state.articleForm ?
                        <div className="table-tabs">
                            <button onClick={() => this.setState({ articleForm: false })}>
                                {'Categories list'.translate(this.props.lamg)}
                            </button>
                            <button className="active" onClick={() => this.setState({ articleForm: {} })}>
                                {'Add new category'.translate(this.props.lang)}
                            </button>
                        </div>
                        : null
                }

                {
                    this.state.articleForm ?

                        <div>
                            <div className="side-margin">
                                <FormBuilder
                                    registerSubmitAction={(submit) => this.submit = submit}
                                    classNameForm={"add-form-container"}
                                    // headerForm={"Article".translate(this.props.lang)}
                                    //                                  addButtonText={this.state.articleForm._id ? 'Edit product'.translate(this.props.lang) :  'Add new'.translate(this.props.lang)}
                                    lang={this.props.lang}
                                    onSubmit={(dat) => {
                                        let data = { ...dat }

                                        data.attributes = [];
                                        data.filters = [];
                                        data.namingAttributes = [];
                                        if (data.attributeKey) {
                                            for (var key in data.attributeKey) {
                                                if (data.attributeKey[key]) {
                                                    data.attributes.push(key);
                                                }
                                            }
                                            delete data.attributeKey;
                                        }

                                        if (data.filterKey) {
                                            for (var key in data.filterKey) {
                                                if (data.filterKey[key]) {
                                                    data.filters.push(key);
                                                }
                                            }
                                            delete data.filterKey;
                                        }
                                        if (data.namingAttributeKey) {
                                            for (var key in data.namingAttributeKey) {
                                                if (data.namingAttributeKey[key]) {
                                                    data.namingAttributes.push(key);
                                                }
                                            }
                                            delete data.namingAttributeKey;
                                        }


                                        if (this.state.articleForm && this.state.articleForm._id) {
                                            console.log(data)
                                            this._api('api4', { data: data }, () => {
                                                this.setState({ articleForm: undefined }, () => { this._onLoad(); })
                                            });
                                        } else {
                                            console.log(data)
                                            this._api('api2', { data: data }, () => {
                                                this.setState({ articleForm: {} }, () => { this._onLoad() })
                                            });
                                        }
                                    }}
                                    initialValues={this.state.articleForm && this.state.articleForm._id ? this.state.articleForm : {}}
                                    fields={[
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Category details'.translate(this.props.lang),
                                                            style: { paddingBottom: 33 },
                                                            children: [
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'name',
                                                                            next: 'password',
                                                                            label: 'Name',
                                                                            multilang: true,
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Name is required!'),
                                                                            ]
                                                                        },

                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'slug',
                                                                            next: 'password',
                                                                            label: 'Slug',
                                                                            multilang: true,
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Slug is required!'),
                                                                            ]
                                                                        },

                                                                    ]
                                                                },
								                                                                    {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'vindTitle',
                                                                            next: 'password',
                                                                            label: 'Vind Category Title',
                                                                            multilang: true,
									    validate: []
                                                                        },

                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'breadcrumb',
                                                                            next: 'password',
                                                                            label: 'Breadcrumb',
                                                                            multilang: true,
                                                                            asyncValidation: true,
                                                                            validate: [
                                                                                required('Breadcrumb is required!'),
                                                                            ]
                                                                        },

                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'position',
                                                                            next: 'password',
                                                                            label: 'Position',
                                                                            asyncValidation: true,
                                                                            validate: []
                                                                        },

                                                                    ]
                                                                },
{
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'vindPosition',
                                                                            next: 'password',
                                                                            label: 'Vind Position',
                                                                            asyncValidation: true,
                                                                            validate: []
                                                                        },

                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'html',
                                                                            height: 200,
                                                                            name: 'description',
                                                                            next: 'password',
                                                                            label: 'Description',
                                                                            multilang: true,
                                                                        },

                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'html',
                                                                            height: 200,
                                                                            name: 'vind.description',
                                                                            next: 'password',
                                                                            label: 'Description VindCollection',
                                                                            multilang: true,
                                                                        },

                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'image.lg',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Desktop image',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'image.xs',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Mobile image',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'homeImage.lg',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home desktop image',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'homeImage.xs',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home mobile image',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },


                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.categoryImage.lg',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Desktop category image VindCollection',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.categoryImage.xs',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Mobile category image VindCollection',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },




                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.image.lg',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Desktop image VindCollection',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.image.xs',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Mobile image VindCollection',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.homeImage.lg[0]',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home desktop image Vind Collection #1',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.homeImage.xs[0]',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home mobile image VindCollection #1',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.homeImage.lg[1]',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home desktop image Vind Collection #2',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'vind.homeImage.xs[1]',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Home mobile image VindCollection #2',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },





                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'icon',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Icon',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'image',
                                                                            name: 'brandImage',
                                                                            endpoint: '/data/categories/upload',
                                                                            label: 'Brand image',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },


                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 6, sm: 12, xs: 12 },
                                                                    children: [
                                                                        {
                                                                            type: 'text',
                                                                            name: 'brandBackgroundColor',
                                                                            label: 'Brand background color',
                                                                            validate: [
                                                                            ]
                                                                        },
                                                                    ]
                                                                },


                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                                    children: [
                                                                    ]
                                                                },


                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 2, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'hidden',
                                                                            next: 'stock',
                                                                            label: 'Hidden',
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 2, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'brandCategory',
                                                                            next: 'stock',
                                                                            label: 'Brand category',
                                                                        }
                                                                    ]
                                                                },

                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 3, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'featuredOnHomePage',
                                                                            next: 'stock',
                                                                            label: 'Featured on home page',
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    type: 'col',
                                                                    width: { lg: 3, sm: 3, xs: 3 },
                                                                    children: [
                                                                        {
                                                                            type: 'switch',
                                                                            name: 'vind.featuredOnHomePage',
                                                                            next: 'stock',
                                                                            label: 'Featured on home page VindCollection',
                                                                        }
                                                                    ]
                                                                },



                                                            ]
                                                        },



                                                    ]
                                                },






                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Attributes'.translate(this.props.lang),
                                                            style: { paddingBottom: 33, marginTop: 20 },
                                                            children: [
                                                                ...this.state.attributes.map((item) => {
                                                                    return {

                                                                        type: 'col',
                                                                        width: { lg: 3, sm: 12, xs: 12 },
                                                                        children: [
                                                                            {
                                                                                type: 'switch',
                                                                                name: 'attributeKey.' + item.key,
                                                                                label: item.name[this.props.lang],

                                                                            }
                                                                        ]



                                                                    }
                                                                })

                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Filters'.translate(this.props.lang),
                                                            style: { paddingBottom: 33, marginTop: 20 },
                                                            children: [
                                                                ...this.state.attributes.map((item) => {
                                                                    return {

                                                                        type: 'col',
                                                                        width: { lg: 3, sm: 12, xs: 12 },
                                                                        children: [
                                                                            {
                                                                                type: 'switch',
                                                                                name: 'filterKey.' + item.key,
                                                                                label: item.name[this.props.lang],

                                                                            }
                                                                        ]



                                                                    }
                                                                })

                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    type: 'col',
                                                    width: { lg: 12, sm: 12, xs: 12 },
                                                    children: [
                                                        {
                                                            type: 'block',
                                                            header: 'Naming Attributes'.translate(this.props.lang),
                                                            style: { paddingBottom: 33, marginTop: 20 },
                                                            children: [
                                                                ...this.state.attributes.map((item) => {
                                                                    return {

                                                                        type: 'col',
                                                                        width: { lg: 3, sm: 12, xs: 12 },
                                                                        children: [
                                                                            {
                                                                                type: 'switch',
                                                                                name: 'namingAttributeKey.' + item.key,
                                                                                label: item.name[this.props.lang],

                                                                            }
                                                                        ]



                                                                    }
                                                                })

                                                            ]
                                                        }
                                                    ]
                                                }


                                            ],
                                        },
                                        {
                                            type: 'row',
                                            children: [
                                                {
                                                    type: 'button',
                                                    width: { lg: 4, sm: 6, xs: 6 },
                                                    action: 'submit',
                                                    children: 'Save',
                                                    className: 'form-button',
                                                },

                                            ]
                                        }

                                    ]}
                                ></FormBuilder>
                            </div>

                        </div>

                        :

                        <div>
                            <DeleteModal
                                isOpen={this.state.deleteModal}
                                toggle={() => this.setState({ deleteModal: null })}
                                handler={() => {
                                    this._api('api3', { data: this.state.deleteModal._id }, () => {
                                        this.setState({ groupsForm: {} }, () => { this._onLoad(); this.setState({ deleteModal: null }) })
                                    });
                                }} >
                                {'Delete customer'.translate(this.props.lang)} <strong>{this.state.deleteModal ? this.state.deleteModal.name[this.props.lang] : ''}</strong> ?
                            </DeleteModal>
                            <ListBuilder
                                tabs={true}
                                sort={true}
                                tab1Name={'Categories list'.translate(this.props.lang)}
                                tab2Name={"Add new category".translate(this.props.lang)}
                                onClickTab1={() => {
                                    this.setState({
                                        articlesList: true,
                                        articleForm: false,
                                    })
                                    this.updateMultipleParams([{ name: 'entries', value: "10" }, { name: 'page', value: 0 }, { name: 'filter', value: '' }], true);
                                }}
                                onClickTab2={() => {
                                    this.setState({
                                        articleForm: true,
                                        articlesList: false
                                    })
                                }}
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'name', label: 'NAME'.translate(this.props.lang), multilang: true, allowSort: true },
                                    { type: 'text', name: 'breadcrumb', label: 'BREADCRUMB'.translate(this.props.lang), multilang: true, allowSort: true },

                                ]}
                                items={this.state.items}

                                actions={
                                    [
                                        {
                                            component: <Isvg src={editIcon} />,
                                            onClick: (item) => {
                                                if (item.attributes) {
                                                    for (let i = 0; i < item.attributes.length; i++)
                                                        item['attributeKey.' + item.attributes[i]] = true;
                                                }
                                                if (item.filters) {
                                                    for (let i = 0; i < item.filters.length; i++)
                                                        item['filterKey.' + item.filters[i]] = true;
                                                }
                                                if (item.namingAttributes) {
                                                    for (let i = 0; i < item.namingAttributes.length; i++)
                                                        item['namingAttributeKey.' + item.namingAttributes[i]] = true;
                                                }

                                                this.setState({ articleForm: null }, () => this.setState({ articleForm: item }))

                                            }
                                        },
                                        {
                                            component: <Isvg src={garbageIcon} />,
                                            onClick: (item) => this.setState({ deleteModal: item })
                                        },
                                    ]
                                }

                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>
                }


            </div >
        )
    }
}

export default Page(Home);

/*

*/
